import type { SubjectTypeGrantPayload } from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionsFetched';

/** Who may use a dossier type: a role or a user, with an access level (`level` is the sent value). */
class SubjectTypeGrantView {
	readonly kind: 'role' | 'user';
	readonly id: number;
	readonly level: string;
	readonly levelLabel: string;

	constructor(payload: SubjectTypeGrantPayload) {
		this.kind = payload.kind;
		this.id = payload.id;
		this.level = payload.level.value;
		this.levelLabel = payload.level.label;

		Object.freeze(this);
	}
}

export default SubjectTypeGrantView;
